import React, { PropsWithChildren } from "react";
import cx from "classnames";
import { focusStyle } from "../../../../constants";

interface Props {
  to: string;
}

const FooterMiniLink = ({ to, children }: PropsWithChildren<Props>) => {
  const footerLinkClassName = cx(
    "hover:underline active:text-grey-shark-5",
    focusStyle
  );

  return (
    <a
      href={to}
      className={footerLinkClassName}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};

export default FooterMiniLink;
